// extracted by mini-css-extract-plugin
export default {"cls1":"JQ7sKmfQsXoDWGffmBKc","cls2":"LXfaq1p25OgaWVb27Zkn JQ7sKmfQsXoDWGffmBKc","isTablet":"fx6_LvU2GAnqB6S1UAot"};